import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import * as devicesApi from "@/services/devicesApi";

interface EnrollDeviceDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export const EnrollDeviceDialog = ({ isOpen, onClose }: EnrollDeviceDialogProps) => {
  const [deviceName, setDeviceName] = useState("");
  const [requiresAuth, setRequiresAuth] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [enrollmentUrl, setEnrollmentUrl] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleEnroll = async () => {
    try {
      setIsLoading(true);
      const result = await devicesApi.inviteUser({
        email: username || deviceName,
      } as any);
      setEnrollmentUrl(typeof result === 'string' ? result : null);
      toast.success('Enrollment invitation sent');
    } catch (error: any) {
      console.error('Enrollment error:', error);
      toast.error(error?.message || 'Failed to enroll device');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Enroll New Device</DialogTitle>
          <DialogDescription>
            Send an enrollment invitation to add a new device.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="deviceName">Device Name / Email</Label>
            <Input id="deviceName" value={deviceName} onChange={(e) => setDeviceName(e.target.value)} placeholder="Enter device name or email" />
          </div>
          {enrollmentUrl && (
            <div className="p-4 bg-muted rounded-lg">
              <Label className="text-sm font-medium">Enrollment URL</Label>
              <p className="text-sm mt-1 break-all text-muted-foreground">{enrollmentUrl}</p>
            </div>
          )}
          <Button onClick={handleEnroll} disabled={isLoading || !deviceName} className="w-full">
            {isLoading ? 'Sending...' : 'Send Enrollment Invitation'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
